import React from "react";

import events_report from "./events_report.png";

const ReportsEvents = () => (
  <div id="reports_events" className="section">
    <h2>4.3 Events Report</h2>
    <p>This report breaks down who has logged on and when.</p>
    <img src={events_report} alt="User Access Report" className="center" />
  </div>
);

export default ReportsEvents;
